// Display-only compatibility catalog for the legacy single-file POS workspace.
// Keys are the original English interface strings; values are neutral Latin
// American Spanish. Operational values and API payloads are never translated.
const CIGAR_RETAIL_ES_419_COPY = {
  "ACCOUNTING BRIDGE": "CONEXIÓN CONTABLE",
  "Accessory": "Accesorio",
  "Active": "Activo",
  "Add Inventory Item": "Agregar Producto al Inventario",
  "Add lounge customer": "Agregar cliente del establecimiento",
  "Age-verification safeguard": "Protección de verificación de edad",
  "Amount tendered": "Monto recibido",
  "Apparel": "Ropa",
  "Apply ordinary sales tax": "Aplicar impuesto general sobre ventas",
  "Apply the separate tobacco tax": "Aplicar el impuesto separado al tabaco",
  "Barcode": "Código de barras",
  "Beverage": "Bebida",
  "Binder": "Capote",
  "Brand": "Marca",
  "Cutters, lighters, apparel…": "Cortadores, encendedores, ropa…",
  "CATALOG, HUMIDOR & STORE": "CATÁLOGO, HUMIDOR Y TIENDA",
  "COGS": "Costo de mercancía vendida",
  "CUSTOMER 360": "CLIENTE 360",
  "Cancel edit": "Cancelar edición",
  "Card-present terminals": "Terminales para pagos presenciales",
  "Cashier": "Cajero",
  "Cashier discount limit (%)": "Límite de descuento del cajero (%)",
  "Category": "Categoría",
  "Choose location": "Elegir ubicación",
  "Choose terminal": "Elegir terminal",
  "Cigar": "Cigarro",
  "Cigar preferences": "Preferencias de cigarros",
  "Close Shift & Lock": "Cerrar Turno y Bloquear",
  "Close register shift": "Cerrar turno de caja",
  "Closed": "Cerrado",
  "Closing notes": "Notas de cierre",
  "Color": "Color",
  "Confirm customer is 21 or older": "Confirmar que el cliente tiene 21 años o más",
  "Connect Square": "Conectar Square",
  "Cost per unit": "Costo por unidad",
  "Cost value": "Valor al costo",
  "Counted cash": "Efectivo contado",
  "Create pairing code": "Crear código de vinculación",
  "Customer": "Cliente",
  "Discount": "Descuento",
  "Discount reason": "Motivo del descuento",
  "Discounts": "Descuentos",
  "Download template": "Descargar plantilla",
  "Edit": "Editar",
  "Email": "Correo electrónico",
  "Employee": "Empleado",
  "Employee PINs": "PIN de empleados",
  "Employee name": "Nombre del empleado",
  "Enable loyalty points for identified customers": "Activar puntos de lealtad para clientes identificados",
  "Enter this code on Square Terminal": "Ingresa este código en la Terminal Square",
  "Expected cash": "Efectivo esperado",
  "Filler": "Tripa",
  "First name": "Nombre",
  "Fixed amount": "Monto fijo",
  "Gross": "Bruto",
  "Gross profit": "Ganancia bruta",
  "Gross sale": "Venta bruta",
  "Import Valid Inventory": "Importar Inventario Válido",
  "Import review": "Revisión de importación",
  "Import spreadsheet": "Importar hoja de cálculo",
  "Inactive": "Inactivo",
  "Independent tax calculations": "Cálculos de impuestos independientes",
  "Inventory": "Inventario",
  "Items": "Productos",
  "Items sold": "Productos vendidos",
  "LOUNGE CONFIGURATION": "CONFIGURACIÓN DEL ESTABLECIMIENTO",
  "Last name": "Apellido",
  "Length": "Largo",
  "Line": "Línea",
  "Line total": "Total de línea",
  "Location": "Ubicación",
  "Lounge customers": "Clientes del establecimiento",
  "Lounge display name": "Nombre visible del establecimiento",
  "Loyalty earning safeguard": "Protección para acumular puntos",
  "Loyalty reward": "Recompensa de lealtad",
  "MEMBERS & GUESTS": "MIEMBROS E INVITADOS",
  "Manager": "Gerente",
  "Manager or shift-lead approval PIN": "PIN de aprobación del gerente o supervisor",
  "Manual discount": "Descuento manual",
  "Material": "Material",
  "Member number": "Número de miembro",
  "Merchandise": "Mercancía",
  "Model or style": "Modelo o estilo",
  "Net revenue": "Ingreso neto",
  "No customers have been added.": "No se han agregado clientes.",
  "No discount": "Sin descuento",
  "No line-item detail is available for this earlier record.": "Este registro anterior no tiene detalles de productos.",
  "No matching retail inventory was found.": "No se encontró inventario que coincida.",
  "No register shifts have been closed.": "No se han cerrado turnos de caja.",
  "No retail POS finance records are waiting.": "No hay registros financieros del POS pendientes.",
  "Non-tobacco redemption safeguard": "Protección para canje en productos sin tabaco",
  "Notes": "Notas",
  "On hand": "Disponible",
  "Optional terminal receipt or note": "Recibo de terminal o nota opcional",
  "Origin": "Origen",
  "Other merchandise": "Otra mercancía",
  "Other tobacco": "Otro producto de tabaco",
  "PAYMENT CONNECTORS": "CONECTORES DE PAGO",
  "PIN": "PIN",
  "Package": "Paquete",
  "Package label": "Nombre del paquete",
  "Paired Square Terminal": "Terminal Square vinculada",
  "Payment reference": "Referencia de pago",
  "Pending review": "Pendiente de revisión",
  "Percentage": "Porcentaje",
  "Phone": "Teléfono",
  "Photo ID checked when the customer appears under 30": "Verificar identificación con foto si el cliente aparenta menos de 30 años",
  "Points earned per dollar": "Puntos obtenidos por dólar",
  "Points to use on eligible non-tobacco items": "Puntos para usar en productos elegibles sin tabaco",
  "Preferred strength, wrappers, brands or vitolas": "Intensidad, capas, marcas o vitolas preferidas",
  "Product": "Producto",
  "Product name": "Nombre del producto",
  "Product type": "Tipo de producto",
  "Promotion, manager courtesy, loyalty reward…": "Promoción, cortesía del gerente, recompensa de lealtad…",
  "Quantity": "Cantidad",
  "REGISTER ACCOUNTABILITY": "RESPONSABILIDAD DE CAJA",
  "REGISTER CONTROL": "CONTROL DE CAJA",
  "Receipt": "Recibo",
  "Recent shift closings": "Cierres de turno recientes",
  "Recorded revenue": "Ingresos registrados",
  "Refresh terminals": "Actualizar terminales",
  "Register": "Caja",
  "Register name": "Nombre de la caja",
  "Register role": "Rol de caja",
  "Register settings": "Configuración de caja",
  "Remove item": "Quitar producto",
  "Reorder at units": "Reponer al llegar a",
  "Require age verification at checkout": "Exigir verificación de edad al cobrar",
  "Retail finance queue": "Cola financiera de ventas",
  "Retail inventory": "Inventario de venta",
  "Retail price per package": "Precio de venta por paquete",
  "Retail price per unit": "Precio de venta por unidad",
  "Ring gauge": "Cepo",
  "SKU": "SKU",
  "Sale note": "Nota de venta",
  "Sales": "Ventas",
  "Sales tax": "Impuesto sobre ventas",
  "Sales tax collected": "Impuesto sobre ventas cobrado",
  "Sales tax rate": "Tasa del impuesto sobre ventas",
  "Save Customer": "Guardar Cliente",
  "Save Employee": "Guardar Empleado",
  "Save Settings": "Guardar Configuración",
  "Search products, barcode, SKU, category or stock location": "Buscar productos, código de barras, SKU, categoría o ubicación",
  "Shift lead": "Supervisor de turno",
  "Size": "Tamaño",
  "Square adapter ready for company setup": "Adaptador de Square listo para configurar",
  "Square connected": "Square conectado",
  "Square is not connected": "Square no está conectado",
  "Square location": "Ubicación de Square",
  "Status": "Estado",
  "Stock location": "Ubicación del inventario",
  "Strength": "Intensidad",
  "Subtotal": "Subtotal",
  "Supplier": "Proveedor",
  "Tax": "Impuestos",
  "Tender": "Forma de pago",
  "Time": "Hora",
  "Tobacco payment safeguard": "Protección para pagos de tabaco",
  "Tobacco tax": "Impuesto al tabaco",
  "Tobacco tax collected": "Impuesto al tabaco cobrado",
  "Tobacco tax rate": "Tasa del impuesto al tabaco",
  "Total": "Total",
  "Total units on hand": "Total de unidades disponibles",
  "Type": "Tipo",
  "Unit": "Unidad",
  "Unit label": "Nombre de la unidad",
  "Unit price": "Precio unitario",
  "Units per package": "Unidades por paquete",
  "Update Item": "Actualizar Producto",
  "Value of each point (cents)": "Valor de cada punto (centavos)",
  "Vitola": "Vitola",
  "Walk-in A2, display case, apparel rack…": "Humidor A2, vitrina, estante de ropa…",
  "Wrapper": "Capa",
  "box, case, pack…": "caja, estuche, paquete…",
  "stick, item, shirt…": "unidad, artículo, camisa…",
  "Inventory changes require an owner, administrator or manager.": "Los cambios de inventario requieren un dueño, administrador o gerente.",
  "This creates the same company contact record used by SBS CRM.": "Esto crea el mismo registro de contacto empresarial que utiliza el CRM de SBS.",
  "Every completed POS sale creates a finance record for review. Sales tax and tobacco tax remain separate liabilities.": "Cada venta completada crea un registro financiero para revisión. El impuesto sobre ventas y el impuesto al tabaco permanecen como obligaciones separadas.",
  "PINs must be unique within this lounge. Existing PINs are never displayed; leave the PIN blank when editing unless it needs to change.": "Los PIN deben ser únicos dentro del establecimiento. Los PIN existentes nunca se muestran; al editar, deja el campo vacío si no necesitas cambiarlo.",
  "Loyalty points may reduce only eligible non-tobacco merchandise. Cigar and tobacco lines remain full price, and the server rejects any redemption larger than the eligible merchandise balance.": "Los puntos de lealtad solo pueden reducir productos elegibles sin tabaco. Los cigarros y productos de tabaco mantienen su precio completo, y el servidor rechaza canjes mayores al saldo elegible.",
  "Points are awarded only after a completed sale to a selected Customer 360 record, based on the merchandise total after discounts. Taxes never earn points.": "Los puntos se otorgan solo después de completar una venta para un registro Cliente 360 seleccionado, según el total de mercancía después de descuentos. Los impuestos nunca generan puntos.",
  "Sales tax is calculated only from the discounted sales-taxable merchandise base. Tobacco tax is calculated separately only from discounted items marked tobacco-taxable. Neither tax is included in the other tax base.": "El impuesto sobre ventas se calcula únicamente sobre la mercancía gravable después de descuentos. El impuesto al tabaco se calcula por separado solo sobre productos marcados como gravables. Ningún impuesto se incluye en la base del otro.",
  "The register requires confirmation that the customer is 21 or older only when the cart contains an age-restricted item. It does not store an ID image or identification number.": "La caja exige confirmar que el cliente tiene 21 años o más solo cuando el carrito contiene un producto restringido por edad. No guarda imágenes ni números de identificación.",
  "SBS keeps the point-of-sale workflow provider-neutral. Square is the first supported direct connector; external terminals remain available for other processors.": "SBS mantiene el flujo del punto de venta independiente del proveedor. Square es el primer conector directo; las terminales externas siguen disponibles para otros procesadores.",
  "The SBS server administrator must add the Square application credentials before a lounge can connect its account.": "El administrador del servidor SBS debe agregar las credenciales de Square antes de que un establecimiento conecte su cuenta.",
  "Connect the lounge's own Square seller account. SBS never uses Selenne Strategies' payment account for lounge sales.": "Conecta la cuenta de vendedor Square del establecimiento. SBS nunca usa la cuenta de pagos de Selenne Strategies para las ventas del establecimiento.",
  "Connected checkout is designed for eligible in-person, card-present sales only. Each lounge remains responsible for Square approval, local law, card-network rules, and its processor agreement. Online or manually keyed tobacco payments are not routed through this connector.": "El cobro conectado está diseñado solo para ventas presenciales elegibles con tarjeta presente. Cada establecimiento sigue siendo responsable de la aprobación de Square, las leyes locales, las reglas de la red de tarjetas y su contrato con el procesador. Los pagos de tabaco en línea o ingresados manualmente no pasan por este conector."
};

export default CIGAR_RETAIL_ES_419_COPY;
